import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/SEO';

import { Home } from './pages/Home';
import { System3E } from './pages/System3E';
import { SadanByggerDu } from './pages/SadanByggerDu';
import { Fordele } from './pages/Fordele';
import { ForPrivate } from './pages/ForPrivate';
import { ForProfessionelle } from './pages/ForProfessionelle';
import { Projekter } from './pages/Projekter';
import { Kontakt } from './pages/Kontakt';
import { NotFound } from './pages/NotFound';
import { Forbidden } from './pages/Forbidden';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans selection:bg-red-600 selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/system-3e" element={<System3E />} />
          <Route path="/sadan-bygger-du" element={<SadanByggerDu />} />
          <Route path="/fordele" element={<Fordele />} />
          <Route path="/for-private" element={<ForPrivate />} />
          <Route path="/for-professionelle" element={<ForProfessionelle />} />
          <Route path="/projekter" element={<Projekter />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
